module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/6_98a7c66d11703cf1a988a7d585441a71.jpg";